var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DatePickerDealButton } from '@honeycomb/ui-core';
import { currentCalendarPrice, currentTripStateIdVar, useGlobalContext, PriceDisplayMode, LocalStorageEnum, } from '@honeycomb/data';
export function HotelPriceCalendarDay(_a) {
    var _b, _c;
    var { calendarPrices, minDealPriceArray, searchStartDate, currentDate, searchEndDate, estabId, day, modifiers } = _a, buttonProps = __rest(_a, ["calendarPrices", "minDealPriceArray", "searchStartDate", "currentDate", "searchEndDate", "estabId", "day", "modifiers"]);
    const { resourceStrings: { HC_DEAL }, } = useGlobalContext();
    const currentDisplayMode = typeof window !== 'undefined'
        ? (_b = window.localStorage.getItem(LocalStorageEnum.PRICE_DISPLAY_MODE)) !== null && _b !== void 0 ? _b : PriceDisplayMode.TotalPrice
        : PriceDisplayMode.TotalPrice;
    const item = calendarPrices === null || calendarPrices === void 0 ? void 0 : calendarPrices.find((e) => new Date(e.date).toDateString() === day.date.toDateString());
    const monthDate = new Date(item === null || item === void 0 ? void 0 : item.date).setHours(0, 0, 0, 0);
    const minDeal = minDealPriceArray === null || minDealPriceArray === void 0 ? void 0 : minDealPriceArray.find((e) => e === (item === null || item === void 0 ? void 0 : item.date));
    const calendarDate = day.date.setHours(0, 0, 0, 0);
    // Used to log pricing differences to datadog
    if (calendarDate === searchStartDate) {
        currentCalendarPrice({
            tripStateId: currentTripStateIdVar(),
            estabId,
            price: (item === null || item === void 0 ? void 0 : item.price) || undefined,
        });
    }
    const isSelected = calendarDate === searchStartDate || calendarDate === searchEndDate;
    const isDayHighlighted = calendarDate >= searchStartDate && calendarDate <= searchEndDate;
    const displayPrice = (monthDate >= currentDate &&
        ((_c = item === null || item === void 0 ? void 0 : item.price) !== null && _c !== void 0 ? _c : 0) > 0 &&
        (currentDisplayMode === PriceDisplayMode.PerPersonPrice
            ? item === null || item === void 0 ? void 0 : item.pricePerPersonFormatted
            : item === null || item === void 0 ? void 0 : item.priceFormatted)) ||
        '';
    return (React.createElement(DatePickerDealButton, Object.assign({ calloutLabel: monthDate >= currentDate && minDeal ? HC_DEAL : '', price: displayPrice, highlighted: isDayHighlighted, selected: isSelected, day: day, modifiers: modifiers }, buttonProps)));
}
